<template>
  <label>
    <input type="file" class="hidden" multiple @change="handleSelect" />
    <i class="el-icon-paperclip cursor-pointer text-white text-3xl"/>
  </label>
</template>

<script>
import FileModel from "@/models/file-model";

export default {
  name: "ButtonAttachment",
  emits: ["add-file"],
  data() {
    return {};
  },
  methods: {
    handleSelect(event) {
      const input = event.target;
      const files = input.files;
      if (files) {
        Array.from(files).forEach((file) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const base64 = e.target && e.target.result;
            this.$emit(
              "add-file",
              new FileModel({
                name: file.name,
                size: file.size,
                type: file.type,
                url: base64,
                file: file,
              })
            );
          };
          reader.readAsDataURL(file);
        });
      }
      input.value = "";
    },
  },
};
</script>
